/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Paragraphs_0Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_1_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cell address combines a column letter and a row number. B4 means column B, row 4. The formula bar lets you inspect the selected cell’s contents, and the tabs along the bottom select worksheets. These three landmarks are enough to start exploring a sample without learning every ribbon command.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_1_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单元格地址由列字母和行号组成，B4 就是 B 列第 4 行。公式栏用于查看选中单元格的内容，底部标签用于切换工作表。掌握这三个位置，就可以先探索示例，无需立即熟悉所有功能区命令。`)
};

/**
* | output |
* | --- |
* | "A cell address combines a column letter and a row number. B4 means column B, row 4. The formula bar lets you inspect the selected cell’s contents, and the ta..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_1_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_1_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_1_paragraphs_0(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_1_paragraphs_0(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_1_paragraphs_0 as "gc.search_guides.what_is_gridcraft.sections.1.paragraphs.0" }